var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDocumentation = function SvgDocumentation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 29 33"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.214 0C2.784 0 0 2.771 0 6.188v20.625C0 30.229 2.783 33 6.214 33H26.93A2.065 2.065 0 0 0 29 30.938c0-1.141-.926-2.063-2.071-2.063V24.75A2.065 2.065 0 0 0 29 22.688V2.063C29 .922 28.074 0 26.929 0h-2.072zm0 24.75h16.572v4.125H6.214a2.065 2.065 0 0 1-2.071-2.062c0-1.141.926-2.063 2.071-2.063",
    opacity: 0.203
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.286 9.281c0-.567.466-1.031 1.035-1.031H21.75c.57 0 1.036.464 1.036 1.031s-.466 1.031-1.036 1.031H9.321c-.57 0-1.035-.464-1.035-1.03M9.321 12.375H21.75c.57 0 1.036.464 1.036 1.031s-.466 1.031-1.036 1.031H9.321c-.57 0-1.035-.464-1.035-1.03 0-.568.466-1.032 1.035-1.032"
  }))));
};
export default SvgDocumentation;